import { Component, Input, ElementRef, ViewChild, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { TAB } from '@angular/cdk/keycodes';
import { MatLegacyChipInputEvent as MatChipInputEvent } from '@angular/material/legacy-chips';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { InlineFieldInterfaceComponent } from '../inline-field-interface.component';
import { PartialFormField } from '../../form-fields/form-field.types';
import { Account } from 'app/core/models/account.types';
import { AccountService } from 'app/core';
import { RelatedToType } from 'app/shared/enums';
import { debounceTime, switchMap } from 'rxjs/operators';
import { Dictionary } from 'app/shared/models';

@Component({
  templateUrl: './tags-inline-field.component.html',
  styleUrls: ['./tags-inline-field.component.scss'],
})
export class TagsInlineFieldComponent extends OnDestroyMixin implements InlineFieldInterfaceComponent, OnInit {
  @ViewChild('inputControl') inputControl: ElementRef;

  @Input() model: any;
  @Input() fieldDef: any;
  @Input() data: any;
  @Input() excludeLabels: boolean = false;
  @Input() readonly: boolean = false;
  @Input() canClick: boolean = false;
  @Output() onClick: EventEmitter<PartialFormField> = new EventEmitter();
  @Output() update: EventEmitter<PartialFormField> = new EventEmitter();

  public editing: boolean = false;
  public value: string[] = [];
  public tags: string[] = [];
  public foundTags: Dictionary<number>;
  account: Account;

  //tags
  tagCtrl: UntypedFormControl;
  separatorKeysCodes: number[] = [TAB];
  visible = true;
  selectable = true;
  removable = true;

  private _originalValue;
  private _readonly;

  @ViewChild('tagInput')
  tagInput: ElementRef<HTMLInputElement>;

  constructor(private _accountService: AccountService) {
    super();
    this._accountService.currentAccount.pipe(untilComponentDestroyed(this)).subscribe((accountData) => {
      this.account = accountData;
    });
  }

  ngOnInit() {
    this.tagCtrl = new UntypedFormControl();

    this.value = this.fieldDef.meta?.value_hidden ? 'REDACTED' : this.model[this.fieldDef.name];
    this._originalValue = this.value;

    if (this.value) {
      this.tags = this.value;
    }

    this.tagCtrl.valueChanges
      .pipe(
        untilComponentDestroyed(this),
        debounceTime(400),
        switchMap((value: string) =>
          this._accountService.getAccountTags(RelatedToType.Project, value).pipe(untilComponentDestroyed(this)),
        ),
      )
      .subscribe((tags) => {
        this.foundTags = tags;
      });

    if (this.fieldDef.meta && this.fieldDef.meta.readonly) {
      this._readonly = this.fieldDef.meta.readonly;
    }
    if (this.readonly) {
      this._readonly = this.readonly;
    }
  }

  edit() {
    if (!this.editing && !this._readonly) {
      this.editing = true;
    }
  }

  onBlur($event: Event) {
    this.onSave();
    this.editing = false;
  }

  onSave() {
    //if(this._originalValue != this.value)
    //{
    this.updateModel();
    this.update.emit({ [this.fieldDef.name]: this.value });
    //}
  }

  updateModel() {
    let list = this.tags.join(',');
    this.model[this.fieldDef.name] = list;
    this._originalValue = this.value;
  }

  addTag(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.tags.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.tagCtrl.setValue(null);
    //this.contactForm.get('tag_list').patchValue(this.contact.tag_list);
  }

  removeTag(tag: string): void {
    // Remove the tag
    this.tags.splice(
      this.tags.findIndex((item) => item === tag),
      1,
    );

    // Update the contact form
    //this.contactForm.get('tag_list').patchValue(this.contact.tag_list);
    //this._changeDetectorRef.markForCheck();
  }

  selectedTag(event: MatAutocompleteSelectedEvent): void {
    this.tags.push(event.option.viewValue);
    this.tagInput.nativeElement.value = '';
    this.tagCtrl.setValue(null);
    //this.contactForm.get('tag_list').patchValue(this.contact.tag_list);
  }

  clickField($event) {
    this.onClick.emit($event);
  }
}
